import { render, staticRenderFns } from "./ComRutaError.vue?vue&type=template&id=245d834b&scoped=true&"
import script from "./ComRutaError.vue?vue&type=script&lang=js&"
export * from "./ComRutaError.vue?vue&type=script&lang=js&"
import style0 from "./ComRutaError.vue?vue&type=style&index=0&id=245d834b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d834b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VContainer,VImg})
